export class ErrorLog {

    moduleName: string;
    userId: string;
    dateAndTime: string;
    errorMethod: string;
    errorDetails: string;
    platform: string;

    // view Variable
    userName: string;
    locationName: String;
}
